import { Icon } from 'antd';
import Link from 'next/link';
import { withRouter } from 'next/router';
import React from 'react';

import Button from '@/src/shared/components/Button';

import handleExcelExport from './excelExport';
import style from './style';

const shouldToggle = (header, isExpand) => {
  const panelActive = header.parentElement.classList.contains('ant-collapse-item-active');
  return isExpand ? !panelActive : panelActive;
};

const handleToggleAll = async isExpand => {
  // eslint-disable-next-line compat/compat
  const allPanelheaders = Array.from(document.getElementsByClassName('outerpanel'));
  allPanelheaders.forEach(p => {
    // eslint-disable-next-line compat/compat
    const headers = Array.from(p.getElementsByClassName('ant-collapse-header'));
    if (shouldToggle(headers[0], isExpand)) {
      headers[0].click();
    }
    headers.splice(0, 1);
    headers
      .filter(innerHeader => shouldToggle(innerHeader, isExpand))
      .forEach((innerHeader, i) => {
        setTimeout(() => {
          innerHeader.click();
        }, i * 100);
      });
  });
};

const handleExpandAll = () => handleToggleAll(true);
const handleCollapseAll = () => handleToggleAll();

const PageButtons = props => {
  const { isDisabled, data, pdfDisabled, pdfDownloading, handleExportToPdf, groupBy, displayChanges } = props;
  const { router } = props;
  const { query } = router;

  const queryString = Object.keys(query)
    .map(k => `${k}=${query[k]}`)
    .join('&');

  const printQueryString = `${queryString}&groupBy=${groupBy}${
    displayChanges ? '&recentChanges=Y' : ''
  }`;

  return (
    <div css={style.btnRow(!isDisabled)}>
      <Button.Group css={style.btnGroup} theme="groupWhite" size="small">
        <Button onClick={handleExpandAll} disabled={!isDisabled}>
          <Icon type="plus" /> Expand All
        </Button>
        <Button onClick={handleCollapseAll} disabled={!isDisabled}>
          <Icon type="minus" /> Collapse All
        </Button>
      </Button.Group>
      <Button.Group css={style.btnGroup} theme="groupWhite" size="small">
        <Button onClickCopy>
          <Icon type="link" /> Copy Link
        </Button>
        <Button disabled={!isDisabled}>
          <Link
            href={`/compliance/compliassist/search?${printQueryString}`}
            // rel="noopener noreferrer"
          > 
            <a target="_blank">
              <Icon type="printer" theme="filled" /> Print
            </a>
          </Link>
        </Button>
        <Button
          onClickExportPDF={handleExportToPdf}
          disabled={!isDisabled || pdfDisabled || pdfDownloading}
        >
          {pdfDownloading ? <Icon type="sync" /> : <Icon type="file-pdf" theme="filled" />} Export
          to PDF
        </Button>
        <Button
          onClick={() => {
            handleExcelExport({
              data,
              sheetTitle: 'CompliAssistExport',
              fileName: displayChanges ? 'CompliAssistRecentChangesExport' : 'CompliAssistExport',
              displayChanges,
            });
          }}
          disabled={!isDisabled}
        >
          <Icon type="file-excel" theme="filled" /> Export to Excel
        </Button>
      </Button.Group>
    </div>
  );
};

PageButtons.propTypes = {};

export default withRouter(PageButtons);
